import apiClient from '../helper/apiClient';

export const getValidateApi = async querystring => {
  const httpClient = apiClient.getInstance();
  const url = apiClient.getValidateUrl();
  const urlPath = `${url}?${querystring}`;
  const response = await httpClient.get(urlPath);
  return response.data;
};
